export default __webpack_public_path__ + "static/media/2019.a6ee5a65.png";